module.exports = __webpack_public_path__ + "img/sad-dog.01a6c7de.jpeg";